import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import muiThemeable from 'material-ui/styles/muiThemeable';

const TagBanners = ({ children }) => (
  <div >
    {children}
  </div>
)

TagBanners.propTypes = {};
TagBanners.defaultProps = {};

export default compose(withRouter, muiThemeable())(TagBanners);




// WEBPACK FOOTER //
// ./src/pages/Banners/children/TagBanners/index.js